import {
  CARE_OFFICE_SEARCH, CARE_OFFICE_SEARCH_SUCCESS, CARE_OFFICE_SEARCH_FAILURE, CARE_OFFICE_CLEAR, CARE_OFFICE_SEARCH_AUTOCOMPLETE_SUCCESS, CARE_OFFICE_AUTOCOMPLETE_CLEAR,
  CARE_OFFICE_SEARCH_DETAIL, CARE_OFFICE_SEARCH_DETAIL_FAILURE, CARE_OFFICE_SEARCH_DETAIL_SUCCESS, CARE_OFFICE_EDIT, CARE_OFFICE_IMAGE_EDIT, CARE_OFFICE_EDIT_FAILURE, CARE_OFFICE_EDIT_SUCCESS,
  CARE_OFFICE_SEARCH_HISTORY, CARE_OFFICE_SEARCH_HISTORY_FAILURE, CARE_OFFICE_SEARCH_HISTORY_SUCCESS, CARE_OFFICE_DETAIL_CLEAR, CARE_OFFICE_EDIT_CLEAR,
  CARE_OFFICE_DELETE, CARE_OFFICE_DELETE_FAILURE, CARE_OFFICE_DELETE_SUCCESS,
  CARE_OFFICE_SEND_MEDINFO, CARE_OFFICE_SEND_MEDINFO_FAILURE, CARE_OFFICE_SEND_MEDINFO_SUCCESS,
  CARE_OFFICE_SET_ENABLE, CARE_OFFICE_SET_ENABLE_FAILURE, CARE_OFFICE_SET_ENABLE_SUCCESS,
  CARE_OFFICE_NOTIFY, CARE_OFFICE_NOTIFY_CLEAR,
  CARE_OFFICE_DUPLICATE_CHECK, CARE_OFFICE_DUPLICATE_CHECK_SUCCESS, CARE_OFFICE_DUPLICATE_CHECK_FAILURE,
  CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF, CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_FAILURE, CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_SUCCESS,
  CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE, CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE, CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS,
  CARE_OFFICE_SHOP_LIST_SAVE, CARE_OFFICE_SEARCH_BY_SHOP, CARE_OFFICE_SEARCH_BY_SHOP_SUCCESS, CARE_OFFICE_SEARCH_BY_SHOP_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    mCareOffice: null,
    images: [],
    careOffice: null,
    careOffices: [],
    careOfficeHistories: null,
    careOfficesAutocomplete: null,
    careOfficesNextPage: 1,
    careOfficesTotalCount: 0,
    careOfficesNextPageLink: null,
    careOfficesCurrentPage: null,
    searchParams: null,
    notify: null,
    shopList: [],
    searchCareOfficesByShop: null
  },
  getters: {
    mCareOffice: state => {
      return state.mCareOffice
    },
    images: state => {
      return state.images
    },
    careOffice: state => {
      return state.careOffice
    },
    careOffices: state => {
      return state.careOffices
    },
    careOfficeHistories: state => {
      return state.careOfficeHistories
    },
    careOfficesAutocomplete: state => {
      return state.careOfficesAutocomplete
    },
    careOfficesNextPage: state => {
      return state.careOfficesNextPage
    },
    careOfficesTotalCount: state => {
      return state.careOfficesTotalCount
    },
    careOfficesNextPageLink: state => {
      return state.careOfficesNextPageLink
    },
    careOfficesCurrentPage: state => {
      return state.careOfficesCurrentPage
    },
    careOfficesSearchParams: state => {
      return state.searchParams
    },
    /** 通知 */
    careOfficeNotify: state => {
      return state.notify
    },
    searchCareOfficesByShop: state => {
      return state.searchCareOfficesByShop
    },
    searchCareOfficesShopList: state => {
      return state.shopList
    }
  },
  actions: {
    [CARE_OFFICE_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/care_offices'
      var loadparams = true
      var autocomplete = false
      var noneList = null
      var callback = () => {}
      if (params) {
        data = params.data
        state.searchParams = params.data
        if ('autocomplete' in params) {
          autocomplete = params.autocomplete
          loadparams = false
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('noneList' in params) {
          noneList = params.noneList
        }
        if ('callback' in params) {
          callback = params.callback
        }
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.careOffices = null
          state.careOfficesNextPage = 0
          state.careOfficesTotalCount = 0
          state.careOfficesNextPageLink = null
          state.careOfficesCurrentPage = null
        }
      }

      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CARE_OFFICE_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            if (autocomplete) {
              commit(CARE_OFFICE_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, noneList: noneList, params: params, callback: callback})
            } else {
              commit(CARE_OFFICE_SEARCH_SUCCESS, {data: res.data, params: params, callback: callback})
            }
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CARE_OFFICE_SEARCH_BY_SHOP] ({dispatch, state, commit}, params) {
      var url = '/care_offices/search_by_shops'
      var data = {}
      var callback = () => {}
      if (params) {
        state.searchParams = params.data
        data = params.data
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CARE_OFFICE_SEARCH_BY_SHOP_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(CARE_OFFICE_SEARCH_BY_SHOP_SUCCESS, {data: res.data, params: params, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [CARE_OFFICE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CARE_OFFICE_CLEAR)
      }, sleep)
    },
    [CARE_OFFICE_DETAIL_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CARE_OFFICE_DETAIL_CLEAR)
      }, sleep)
    },
    [CARE_OFFICE_EDIT_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CARE_OFFICE_EDIT_CLEAR)
      }, sleep)
    },
    [CARE_OFFICE_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(CARE_OFFICE_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },
    [CARE_OFFICE_SEARCH_DETAIL]  ({dispatch, state, commit}, params) {
      dispatch('apiGet', {url: '/care_offices/' + params.data.careOfficeId, data: {}})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_SEARCH_DETAIL_FAILURE, {data: res.data, callback: params.callback})
            } else {
              commit(CARE_OFFICE_SEARCH_DETAIL_SUCCESS, {data: res.data.data, callback: params.callback})
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_SEARCH_HISTORY] ({dispatch, state, commit}, params) {
      dispatch('apiGet', { url: '/care_offices/hist', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_SEARCH_HISTORY_FAILURE, { data: res.data, callback: params.callback })
            } else {
              commit(CARE_OFFICE_SEARCH_HISTORY_SUCCESS, { data: res.data.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_EDIT]  ({dispatch, state, commit}, params) {
      dispatch('apiPost', {url: '/care_offices', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_EDIT_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_EDIT_SUCCESS, { data: res.data.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_IMAGE_EDIT]  ({dispatch, state, commit}, params) {
      dispatch('apiPost', {url: '/care_offices/image_save', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_EDIT_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_EDIT_SUCCESS, { data: res.data.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_DELETE]  ({dispatch, state, commit}, params) {
      dispatch('apiDelete', {url: '/care_offices/' + params.data.historyId})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_DELETE_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_DELETE_SUCCESS, { data: res.data.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** メール通知 */
    [CARE_OFFICE_SEND_MEDINFO] ({dispatch, state, commit}, params) {
      dispatch('apiGet', {url: '/care_offices/send_medinfo', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_SEND_MEDINFO_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_SEND_MEDINFO_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** ログインID・パスワード通知PDF印刷 */
    [CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF] ({dispatch, state, commit}, params) {
      var url = '/care_offices/print_notify'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_SUCCESS, {
                data: res.data,
                callback: params.callback,
                win: params.win
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    /** ログインID・パスワード通知PDF印刷削除 */
    [CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE] ({dispatch, state, commit}, params) {
      var url = '/care_offices/print_notify_delete'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: false})
        .then(res => {
          if (res.data.error) {
            commit(CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE, res.data)
          } else {
            commit(CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS, {
              data: res.data
            })
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_SET_ENABLE] ({dispatch, state, commit}, params) {
      dispatch('apiPatch', {url: '/care_offices/set_enable', data: params.data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_SET_ENABLE_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_SET_ENABLE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_NOTIFY] ({state, commit}, params) {
      state.notify = {
        success: params.success,
        danger: params.danger,
        message_i18n: params.message
      }
      var sleep = params.sleep ? params.sleep : constant.notifyShowTime.normal
      setTimeout(() => {
        commit(CARE_OFFICE_NOTIFY_CLEAR)
      }, sleep)
    },
    [CARE_OFFICE_NOTIFY_CLEAR] ({state, commit}, sleep = constant.notifyShowTime.normal) {
      setTimeout(() => {
        commit(CARE_OFFICE_NOTIFY_CLEAR)
      }, sleep)
    },
    [CARE_OFFICE_DUPLICATE_CHECK] ({dispatch, state, commit}, params) {
      dispatch('apiGet', {url: '/care_offices/duplicate_check', data: params.data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(CARE_OFFICE_DUPLICATE_CHECK_FAILURE, res.data)
            } else {
              commit(CARE_OFFICE_DUPLICATE_CHECK_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [CARE_OFFICE_SHOP_LIST_SAVE] ({state, commit}, params) {
      commit(CARE_OFFICE_SHOP_LIST_SAVE, params)
    }
  },
  mutations: {
    [CARE_OFFICE_SEARCH_FAILURE] (state, data) {
      console.log('CARE_OFFICE_SEARCH_FAILURE')
      if (data && data.callback) {
        data.callback(null)
      }
    },
    [CARE_OFFICE_SEARCH_SUCCESS] (state, {data, params}) {
      console.log('CARE_OFFICE_SEARCH_SUCCESS')
      var reSearch = false

      var sendFailsMerge = function (rows, meta) {
        if (meta && !('send-fails' in meta)) {
          return rows
        }
        var result = []
        var sendFails = meta['send-fails']
        rows.forEach(function (row) {
          for (var i = 0; i < sendFails.length; i++) {
            if (parseInt(row['id'], 10) === parseInt(sendFails[i]['careoffice-id'], 10)) {
              row.attributes['send-fails'] = sendFails[i]['send-fails']
              break
            }
          }
          result.push(row)
        })
        return result
      }

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      state.careOfficesTotalCount = 0

      if (reSearch) {
        // 再検索
        state.careOffices = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.careOfficesNextPage = null
        }
      } else {
        if (data.meta) {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.careOffices = state.careOffices.concat(data.data)
            state.careOfficesCurrentPage = data.meta['current-page']
          } else {
            state.careOffices = data.data
            state.careOfficesCurrentPage = data.meta['current-page']
          }
          state.careOfficesNextPage = null
          if (data.meta['next-page']) {
            state.careOfficesNextPage = data.meta['next-page']
          }
        } else {
          state.careOffices = data.data
        }
        if (data.links && data.links['next']) {
          state.careOfficesNextPageLink = data.links['next']
        } else {
          state.careOfficesNextPageLink = null
        }
      }

      if (data.meta && data.meta['total-count']) {
        state.careOfficesTotalCount = data.meta['total-count']
      }

      // 送信失敗件数
      state.careOffices = sendFailsMerge(state.careOffices, data.meta)

      // 先頭に全項目を追加
      if (params.all && params.care_office_all !== null) {
        state.careOffices.unshift({'id': params.care_office_all['id'], 'attributes': {'careoffice-name': params.care_office_all['name']}})
      }

      if (params.callback) {
        params.callback()
      }
    },
    [CARE_OFFICE_CLEAR] (state) {
      state.careOffices = null
    },
    [CARE_OFFICE_DETAIL_CLEAR] (state) {
      state.doctorHistories = null
    },
    [CARE_OFFICE_EDIT_CLEAR] (state) {
      state.doctor = null
    },
    [CARE_OFFICE_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('CARE_OFFICE_SEARCH_AUTOCOMPLETE_SUCCESS')
      var data = param.data.data
      state.careOfficesAutocomplete = data
      // なし追加
      if (param.noneList !== null) {
        if (state.careOfficesAutocomplete === null) {
          state.careOfficesAutocomplete = []
        }
        state.careOfficesAutocomplete.unshift({'id': param.noneList['id'], 'type': 'careoffices', 'attributes': {'careoffice-name': param.noneList['name'], 'careoffice-name-furigana': ''}})
      }

      // 先頭に全項目を追加
      var params = param.params
      if (params.all && params.care_office_all !== null) {
        state.careOfficesAutocomplete.unshift({'id': params.care_office_all['id'], 'attributes': {'careoffice-name': params.care_office_all['name']}})
      }
    },
    [CARE_OFFICE_AUTOCOMPLETE_CLEAR] (state) {
      state.careOfficesAutocomplete = null
    },
    [CARE_OFFICE_SEARCH_DETAIL_FAILURE] (state, data) {
      console.log('CARE_OFFICE_SEARCH_DETAIL_FAILURE')
      if (data.callback) {
        data.callback(null)
      }
    },
    [CARE_OFFICE_SEARCH_DETAIL_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_SEARCH_DETAIL_SUCCESS')
      var hists = []
      for (var o of data.data.histories) {
        hists.push(o.history)
      }
      state.careOfficeHistories = hists
      state.mCareOffice = data.data.master
      state.images = data.data.images
      if (data.callback) {
        data.callback(hists)
      }
    },
    [CARE_OFFICE_SEARCH_HISTORY_FAILURE] (state, data) {
      console.log('CARE_OFFICE_SEARCH_HISTORY_FAILURE')
      if (data.callback) {
        data.callback(null)
      }
    },
    [CARE_OFFICE_SEARCH_HISTORY_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_SEARCH_HISTORY_SUCCESS')
      var o = data.data
      state.careOffice = o.history
      state.mCareOffice = o.master
      if (data.callback) {
        data.callback(o)
      }
    },
    [CARE_OFFICE_EDIT_FAILURE] (state, data) {
      console.log('CARE_OFFICE_EDIT_FAILURE')
      // 通知
      state.notify = {
        danger: true,
        message_i18n: data.error
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [CARE_OFFICE_EDIT_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_EDIT_SUCCESS')
      state.careOffice = data.data
      if (data.callback) {
        data.callback()
      }
      // 通知
      state.notify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [CARE_OFFICE_DELETE_FAILURE] (state, data) {
      console.log('CARE_OFFICE_DELETE_FAILURE')
      // 通知
      state.notify = {
        danger: true,
        message_i18n: 'messages.delete.danger'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [CARE_OFFICE_DELETE_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_DELETE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
      // 通知
      state.notify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [CARE_OFFICE_SEND_MEDINFO_FAILURE] (state, data) {
      console.log('CARE_OFFICE_SEND_MEDINFO_FAILURE')
      // 通知
      state.notify = {
        danger: true,
        message_i18n: 'messages.send_medinfo.danger'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [CARE_OFFICE_SEND_MEDINFO_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_SEND_MEDINFO_SUCCESS')
      if (data.callback) {
        data.callback()
      }
      // 通知
      state.notify = {
        success: true,
        message_i18n: 'care_office.loginid_password_notice_message'
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    /** ログインID・パスワード通知PDF印刷 失敗 */
    [CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_FAILURE] (state, data) {
      console.log('CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_FAILURE')
      // 通知
      state.facilityDetailNotify = {
        danger: true,
        message_i18n: 'messages.print.danger'
      }
      setTimeout(() => {
        state.facilityDetailNotify = null
      }, constant.notifyShowTime.normal)
    },
    /** ログインID・パスワード通知PDF印刷 成功 */
    [CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_SUCCESS] (state, params) {
      console.log('CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_SUCCESS')
      if (params.callback !== null) {
        params.callback(params.data, params.win)
      }
    },
    /** ログインID・パスワード通知印刷削除失敗 */
    [CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE] (state, params) {
      console.log('CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_FAILURE')
    },
    /** ログインID・パスワード通知印刷削除成功 */
    [CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_DETAIL_PRINT_NOTIFY_PDF_DELETE_SUCCESS')
    },
    [CARE_OFFICE_SET_ENABLE_FAILURE] (state, data) {
      console.log('CARE_OFFICE_SET_ENABLE_FAILURE')
    },
    [CARE_OFFICE_SET_ENABLE_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_SET_ENABLE_SUCCESS')
      state.mCareOffice = data.data.master
      if (data.callback) {
        data.callback()
      }
      // 通知
      var msg = (state.mCareOffice.enable_flag) ? 'care_office.set_enable_success_message' : 'care_office.set_disable_success_message'
      state.notify = {
        success: true,
        message_i18n: msg
      }
      setTimeout(() => {
        state.notify = null
      }, constant.notifyShowTime.normal)
    },
    [CARE_OFFICE_NOTIFY_CLEAR] (state) {
      state.notify = ''
    },
    [CARE_OFFICE_DUPLICATE_CHECK_FAILURE] (state, data) {
      console.log('CARE_OFFICE_DUPLICATE_CHECK_FAILURE')
    },
    [CARE_OFFICE_DUPLICATE_CHECK_SUCCESS] (state, data) {
      console.log('CARE_OFFICE_DUPLICATE_CHECK_SUCCESS')
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [CARE_OFFICE_SEARCH_BY_SHOP_FAILURE] (state, data) {
      console.log('CARE_OFFICE_SEARCH_BY_SHOP_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [CARE_OFFICE_SEARCH_BY_SHOP_SUCCESS] (state, {data, params}) {
      console.log('CARE_OFFICE_SEARCH_BY_SHOP_SUCCESS')
      if (params.callback) {
        state.searchCareOfficesByShop = data.data
        params.callback(data)
      }
    },
    [CARE_OFFICE_SHOP_LIST_SAVE] (state, params) {
      console.log('CARE_OFFICE_SHOP_LIST_SAVE')
      state.shopList = params
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/care-office.js